import { render, staticRenderFns } from "./RewardsListView.vue?vue&type=template&id=2e76fe48&scoped=true&"
import script from "./RewardsListView.vue?vue&type=script&lang=js&"
export * from "./RewardsListView.vue?vue&type=script&lang=js&"
import style0 from "./RewardsListView.vue?vue&type=style&index=0&id=2e76fe48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e76fe48",
  null
  
)

export default component.exports